// extracted by mini-css-extract-plugin
export default {"input":"InputText_input__ToCmA","input__field":"InputText_input__field__6M0zn","input__btn":"InputText_input__btn__sW5V5","input__img":"InputText_input__img__pcEsG"};